import React, { useState } from "react";
import { Box, Typography, IconButton, Popover } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import InputPlaceholderGuide from "./InputPlaceholderGuide";

const InfoTooltip = () => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <>
            {/* כפתור מידע שמפעיל את ה-Popover */}
            <IconButton
                onClick={handleClick}
                sx={{
                    mt: 1.5,
                    zIndex: 9999,
                    backgroundColor: open ? "rgb(231, 231, 231)" : "transparent",
                }}
            >
                <Box display="flex" alignItems="center">
                    <InfoIcon sx={{ color: "#1976d2", marginRight: 0 }} />
                    {/* <Typography variant="body2">קרא אותי</Typography> */}
                </Box>
            </IconButton>

            {/* Popover של Material-UI */}
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                PaperProps={{
                    sx: {
                        width: 700,
                        padding: 2,
                        backgroundColor: "rgb(231, 231, 231)",
                        borderRadius: 2,
                        textAlign: "left",
                        direction: "ltr",
                    },
                }}
            >
                <InputPlaceholderGuide />
            </Popover>
        </>
    );
};

export default InfoTooltip;